import { create } from "zustand";

export type ToastType = "success" | "error" | "info" | "warning";

interface ToastState {
  message: string;
  type: ToastType;
  isVisible: boolean;
  duration: number;
  showToast: (
    message: string,
    options?: {
      type?: ToastType;
      duration?: number;
    }
  ) => void;
  hideToast: () => void;
}

export const useToastStore = create<ToastState>((set) => ({
  message: "",
  type: "info",
  isVisible: false,
  duration: 2000,

  showToast: (message, options = {}) => {
    const { type = "info", duration = 2000 } = options;
    set({ message, type, isVisible: true, duration });
  },

  hideToast: () => {
    set({ isVisible: false });
  },
}));
